import { useState, useEffect, useCallback } from "react";
import { IoAdd, IoRemoveCircleOutline } from "react-icons/io5";

import Toaster from "../../../../components/common/Toaster";
import Modal from "../../../../components/common/Modal";
import CorFormsConfirmation from "./CorFormsConfirmation";
import CorFormsForm from "./CorFormsForm";

import complianceService from "../../../../services/complianceService";
import moment from "moment";

const CorForms = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [taxTypes, setTaxTypes] = useState([]);

  const [taxType, setTaxType] = useState(null);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const fetchTaxTypes = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        if (data) {
          const result = await complianceService.getCORFormsAsync(data.id);

          if (mounted) {
            setTaxTypes(result);
            setIsLoading(false);
          }
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [data]
  );

  const handleConfirmation = (item) => {
    const result = item ?? null;
    setTaxType(result);
    setShowConfirmation(!showConfirmation);
  };

  const handleSubmit = async (items) => {
    try {
      setIsFormLoading(true);

      const cor_forms = [];

      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < items[i].forms.length; j++) {
          const form = items[i].forms[j];
          const item = {};
          item["certificate_of_registration_id"] = data.id;
          item["tax_type_form_id"] = form.id;

          cor_forms.push(item);
        }
      }

      const result = await complianceService.saveCORFormsAsync(cor_forms);

      const result_items = result.map((item) => {
        const data = { ...item };
        data["tax_type_form"] = item.form;
        data["deadline"] = moment(item.deadline).format("DD-MMM-YYYY");

        return data;
      });

      setTaxTypes([...taxTypes, ...result_items]);
      setIsFormLoading(false);

      Toaster.Success("Tax Type Added Successfully");
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setIsFormLoading(false);
    }
  };

  const handleDeleteSuccess = (item) => {
    const items = taxTypes.filter((i) => i.id !== item.id);
    setTaxTypes(items);
    handleConfirmation();
  };

  useEffect(() => {
    let mounted = true;

    fetchTaxTypes(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchTaxTypes]);

  return (
    <div className="p-8">
      {isLoading && (
        <div className="flex-1 space-y-3 py-1 animate-pulse">
          <div className="h-4 bg-gray-100 rounded w-3/5"></div>
          <div className="h-4 bg-gray-100 rounded w-5/5"></div>
          <div className="h-4 bg-gray-100 rounded w-4/5"></div>
          <div className="h-4 bg-gray-100 rounded w-2/5"></div>
        </div>
      )}
      {taxTypes.length > 0 && !isLoading && (
        <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
          {taxTypes.map((item, index) => {
            return (
              <li
                key={index}
                className="pl-3 pr-4 py-3 flex justify-between text-gray-400 text-sm"
              >
                <div className="flex justify-between">
                  <div>
                    <p>{item.tax_type}</p>
                    <span>{item.tax_type_form}</span>
                  </div>
                </div>
                <div>
                  {taxTypes.length > 1 && (
                    <IoRemoveCircleOutline
                      onClick={() => handleConfirmation(item)}
                      className="bg-white px-1 text-xl top-0 text-red-500 cursor-pointer"
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
      <div className="float-right my-5">
        <div
          onClick={() => setShowForm(true)}
          className="flex items-center text-sm text-blue-400 cursor-pointer"
        >
          <IoAdd />
          <span className="ml-3">Add Tax Type</span>
        </div>
      </div>
      <Modal
        isOpen={showConfirmation}
        isLoading={isFormLoading}
        onClose={() => handleConfirmation()}
      >
        <CorFormsConfirmation
          data={taxType}
          isLoading={isFormLoading}
          setLoading={isFormLoading}
          onClose={handleConfirmation}
          onSuccess={handleDeleteSuccess}
        />
      </Modal>
      <Modal
        title="Add Tax Type"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <CorFormsForm
          data={taxTypes}
          onSubmit={handleSubmit}
          onClose={setShowForm}
        />
      </Modal>
    </div>
  );
};

export default CorForms;
